<template>
    <b-card>
        <b-alert variant="danger" :show="showAlert">
            {{ alert }}
        </b-alert>
        <b-form @submit.prevent="startFiscalization">
            <b-form-group :label="$t('kkm.registration')" label-cols-sm="3">
                <b-form-input v-model="formData.registrationNumber"></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('kkm.startFiscalDate')" label-cols-sm="3">
                <date-picker v-model="formData.startDate" type="datetime" format="DD.MM.YYYY HH:mm:ss"
                    input-class="form-control" :clearable="false" confirm :first-day-of-week="1"
                    :lang="datePickerLocale"></date-picker>
            </b-form-group>
            <b-form-group :label="$t('kkm.comment')" label-cols-sm="3">
                <b-form-input v-model="formData.comment"></b-form-input>
            </b-form-group>
            <b-form-group v-show="isOperator" :label="$t('general.attachment')" label-cols-sm="3">
                <b-form-file @change="fileChanged" :browse-text="$t('general.selectFile')"></b-form-file>
                <b-form-text id="inputLiveHelp">
                    {{ $t('general.fileSizeMessage') }}
                </b-form-text>
            </b-form-group>
            <b-form-row class="justify-content-end mx-0">
                <b-button type="submit" variant="success" :disabled="isDisabled">
                    <save-icon title="" />&nbsp;{{ $t('general.save') }}
                </b-button>
            </b-form-row>
        </b-form>
    </b-card>
</template>

<script>
/* eslint-disable */
export default {
    name: 'KkmStartFiscalForm',
    props: {
        sfdNum: String,
        startFiscalResponse: Function,
        isOperator: Boolean
    },
    data () {
        return {
            alert: '',
            showAlert: false,
            isDisabled: false,
            formData: {
                sfdNumber: this.sfdNum,
                startDate: new Date(),
                registrationNumber: '',
                comment: '',
                document: null
            },
            datePickerLocale: this.$store.getters.locale.toLowerCase()
        }
    },
    methods: {
        startFiscalization: function () {
            this.$request.sendRequest(this, this.$appConfig.apiUrls.kkm.startFiscal,
                this.formData, result => {
                    this.startFiscalResponse(result)
                }, this.displayAlert)
        },
        fileChanged: function (event) {
            var onFileRead = this.onFileRead
            var reader = new FileReader()
            reader.onload = function () {
                var arrayBuffer = this.result
                var array = new Uint8Array(arrayBuffer)
                onFileRead(array.toString())
            }
            var files = event.target.files
            reader.readAsArrayBuffer(files[0])
        },
        onFileRead: function (attachment) {
            this.formData.document = attachment
        },
        displayAlert: function (errorCode) {
            this.alert = this.$i18n.t(`errors.${errorCode}`)
            this.showAlert = true
        }
    }
}
</script>
